export default "__VITE_ASSET__wysaUmmc__"